import { render } from "./ClientePerfilView.vue?vue&type=template&id=0f661908"
import script from "./ClientePerfilView.vue?vue&type=script&lang=js"
export * from "./ClientePerfilView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__